import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
export const AnalyticsAttributesContext = createContext({});
export function useAnalyticsAttributes() {
    const context = useContext(AnalyticsAttributesContext);
    if (context === undefined) {
        throw new Error('`useAnalyticsAttributes` must be used within a `AnalyticsContext.Provider`');
    }
    return context;
}
export function AnalyticsAttributesProvider({ value, children }) {
    const analyticsAttributes = useAnalyticsAttributes();
    return (_jsx(AnalyticsAttributesContext.Provider, Object.assign({ value: Object.assign(Object.assign({}, analyticsAttributes), value) }, { children: children }), void 0));
}
//# sourceMappingURL=use-analytics-attributes.js.map